import { DetailState } from './types'

export const initialDetailState: DetailState = {
  currentListId: null,
  activeTab: 'import_history',
}
